import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/Card";

interface CountRow {
  label: string;
  count: number;
}

interface ActivitiesData {
  totalActivities: number;
  totalHours: number;
  byService: CountRow[];
  byProgram: CountRow[];
  byFunder: CountRow[];
  byStaff: CountRow[];
  bySite: CountRow[];
}

interface ActivitiesReportProps {
  data: ActivitiesData;
}

function BreakdownTable({ title, items }: { title: string; items: CountRow[] }) {
  if (items.length === 0) return null;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/50">
              <th className="px-4 py-2 text-left font-medium text-muted-foreground">Name</th>
              <th className="px-4 py-2 text-right font-medium text-muted-foreground">Count</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.label} className="border-b last:border-0 hover:bg-muted/30">
                <td className="px-4 py-2">{item.label}</td>
                <td className="px-4 py-2 text-right font-mono">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}

export function ActivitiesReport({ data }: ActivitiesReportProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-lg border bg-primary/5 p-4">
          <p className="text-sm text-muted-foreground">Total Activities</p>
          <p className="text-2xl font-bold text-primary">{data.totalActivities}</p>
        </div>
        <div className="rounded-lg border bg-primary/5 p-4">
          <p className="text-sm text-muted-foreground">Total Hours</p>
          <p className="text-2xl font-bold text-primary">{data.totalHours}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <BreakdownTable title="By Program" items={data.byProgram} />
        <BreakdownTable title="By Funder" items={data.byFunder} />
        <BreakdownTable title="By Staff" items={data.byStaff} />
        <BreakdownTable title="By Site" items={data.bySite} />
        <BreakdownTable title="By Service Type" items={data.byService} />
      </div>
    </div>
  );
}
